import {browserStorageKey} from '@dms/config';

const isDev = process.env.ENV_TYPE === 'dev';

/**
 * Dev-only logging of writes to the app-context store, called from the store Proxy's `set` trap.
 *
 * Logs the changed key/value to the console when running in dev AND the
 * `AI_ASSISTANT_STORE_LOGGING_ENABLED` localStorage flag is `"true"` (toggle it in
 * dev-settings → "AI assistant context"). No-op in every other case, so it is safe to call on
 * every write. The flag is read live on each call, so toggling it takes effect without a reload.
 */
export const logAiAssistantStoreSet = (key: string, value: unknown) => {
  const isLoggingEnabled =
    localStorage.getItem(browserStorageKey.AI_ASSISTANT_STORE_LOGGING_ENABLED) === 'true';

  if (isDev && isLoggingEnabled) {
    // eslint-disable-next-line no-console -- dev-only store logging gated behind a localStorage flag
    console.log('[Omnetic AI store] set', {[key]: value});
  }
};
